// extracted by mini-css-extract-plugin
export default {"videomodal":"video_videomodal__Zn4wc","close":"video_close__FLw6H","videoClose":"video_videoClose__wR8xG"};